<template>
  <SogCard class="sog-card">
    <SogCardContent>
      <SogForm
        v-show="_edit"
        ref="_form"
      >
        <SogFormField v-show="_editLogin">
          <SogTextBox
            v-model="_loginName"
            placeholder="Benutzername"
            autocomplete="false"
            name="Loginname"
          />
        </SogFormField>
        <SogFormField>
          <SogTextBox
            v-show="_isShowEmail"
            v-model="_email"
            placeholder="Email"
            autocomplete="false"
            name="Email"
          />
        </SogFormField>
        <SogFormField v-show="_isShowTooFactor">
          <SogSwitch
            v-model="_twoFactorAuthentication"
            placeholder="2 Faktor"
          />
        </SogFormField>
      </SogForm>
      <table v-show="!_edit">
        <tr>
          <td>Benutzername</td>
          <td>
            <SogDataLabel :value="_loginName" />
          </td>
        </tr>
        <tr v-show="!_edit && _loginName!==_email">
          <td>Email</td>
          <td>
            <SogDataLabel :value="_email" />
          </td>
        </tr>
        <tr>
          <td>2 Faktor</td>
          <td>
            <span
              v-show="_twoFactorAuthentication"
              class="e-badge e-badge-success e-badge-pill"
            >ja</span><span
              v-show="!_twoFactorAuthentication"
              class="e-badge e-badge-danger e-badge-pill"
            >nein</span>
          </td>
        </tr>
      </table>
    </SogCardContent>
    <SogCardActions>
      <SogCardActionButton
        v-show="_edit&&_editLogin"
        mdi-icon="mdi-account-plus"
        @click="onCreate"
      >
        Benutzer erstellen
      </SogCardActionButton>
      <SogCardActionButton
        v-show="!_edit&&_loginName&&_isShowEmail"
        mdi-icon="mdi-pencil"
        @click="onEditAccount"
      />
      <SogCardActionButton
        v-show="!_edit&&!_loginName"
        mdi-icon="mdi-account-plus"
        @click="onEdit"
      />
      <SogCardActionButton
        v-show="!_edit && _loginName"
        mdi-icon="mdi-delete"
        tooltip="Benutzer löschen"
        @click="onDelete"
      />
      <SogCardActionButton
        v-show="!_edit && props.account.loginName"
        mdi-icon="mdi-form-textbox-password"
        tooltip="Kennwort zurücksetzen"
        @click="onResetPassword"
      />
      <SogCardActionButton
        v-show="_edit&&!_editLogin"
        mdi-icon="mdi-content-save"
        @click="onSaveEmail"
      />

      <!--
      <SogCardActionButton
        v-show="_edit"
        mdi-icon="mdi-account-search"
        @click="onCheck"
      />
-->
      <SogCardActionButton
        v-show="_create"
        mdi-icon="mdi-account-plus"
        @click="onCreate"
      >
        Benutzer erstellen
      </SogCardActionButton>
      <!--
      <SogCardActionButton
        v-show="_checked"
        mdi-icon="mdi-content-save"
        @click="onSave"
      />
-->
      <SogCardActionButton
        v-show="_edit||_create"
        mdi-icon="mdi-cancel"
        @click="onCancel"
      />
    </SogCardActions>
  </SogCard>
</template>

<script setup lang="ts">
import {onMounted, ref, watch} from "vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import Account from "@/shared/model/Account";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import apiOrganisationStructure from "@/modules/OrganisationStructure/api";
import {useAccountStore} from "@/stores/accountStore";
import notificationService from "@/shared/services/NotificationService";
import {Action} from "@/shared/model/Action";
import SogForm from "@/shared/ui/SogForm.vue";
import getGuid from "@/shared/utils/getGuid";
import SogSwitch from "@/shared/ui/SogSwitch.vue";
import Person from "@/shared/model/person";


const _edit = ref(false)
const _editLogin = ref(false)
const _checked = ref(false)
const _create = ref(false)
const _loginName = ref("")
const _email = ref("")
const _isAgent22 = ref(false)
const _accountStore = useAccountStore();
const _isShowEmail = ref(false)
const _twoFactorAuthentication = ref(false);
const _isShowTooFactor = ref(false);
const _form = ref<InstanceType<typeof SogForm> | null>(null)


interface Props {
  account?: Account
  person?: Person
  changed?: () => void;
}

const props = withDefaults(defineProps<Props>(), {
    account: undefined, person: undefined, changed: undefined
  }
)

function onEdit() {
  _edit.value = true
  _create.value = false;
  _checked.value = false;
  _editLogin.value = true;
}

function onCancel() {
  _edit.value = false
  _create.value = false;
  _checked.value = false;
  _editLogin.value = false
  _loginName.value = props.account?.loginName ?? ""
  _email.value = props.account?.email ?? ""
}


async function onResetPassword() {
  if (!_accountStore.hasAction(Action.AccountManage)
  ) {
    notificationService.error("Zugriff verweigert")
    return;
  }
  notificationService.showYesNo("", "Wollen Sie Kennwort für " + _loginName.value + " zurücksetzen?", async () => {

    const password = _email.value ? p_createPassword() : _loginName.value.toLowerCase()

    if (await apiOrganisationStructure.resetPassword(_loginName.value, password)) {
      notificationService.info("Kennwort wurde zurückgesetzt")
    }
  })

}

async function onDelete() {
  if (!_accountStore.hasAction(Action.AccountManage)
  ) {
    notificationService.error("Zugriff verweigert")
    return;
  }
  notificationService.showYesNo("", "Wollen Sie Benutzer " + _loginName.value + " löschen?", async () => {

    if (await apiOrganisationStructure.delete(_loginName.value)) {
      notificationService.info("Benutzer wurde gelöscht")
      doChange();
    }
  })

}

async function onCreate() {
  if (!_accountStore.hasAction(Action.AccountManage)) {
    notificationService.error("Zugriff verweigert")
    return;
  }
  if (!_form.value.validate())
    return

  const resCheck = await apiOrganisationStructure.checkAccount(_loginName.value)
  if (resCheck) {
    notificationService.error("Benutzername bereits vergeben")
    return;
  }

  if (!_isShowEmail.value) {
    _email.value = _loginName.value
  }

  const res = await apiOrganisationStructure.createAccount(_loginName.value, props.account?.personId ?? "", props.account?.actionPersonId ?? "", _email.value)
  if (res) {
    notificationService.info("Benutzer wurde erstellt.")
    const password = _email.value ? p_createPassword() : _loginName.value.toLowerCase()
    await apiOrganisationStructure.resetPassword(_loginName.value?.toLowerCase(), password)
    _edit.value = false
    _create.value = false;
    _checked.value = false;
    doChange();
  }
}

function doChange() {
  if (props.changed)
    props?.changed()
}

/*
async function onCheck() {
  if (!_accountStore.hasAction(Action.AccountManage)) {
    notificationService.error("Zugriff verweigert")
    return;
  }
  if (!_form.value.validate())
    return
  const res = await apiOrganisationStructure.checkAccount(_loginName.value)
  if (res !== undefined) {
    /!*
        if(_isAgent22.value) {
          _create.value = !res;
          _checked.value = true;
        }
        else{
    *!/
    if (res) {
      notificationService.error("Benutzername bereits vergeben")
      return;
    } else {
      _create.value = true;
      _edit.value = false;
    }
//    }
  }
}
*/

function onEditAccount() {
  _edit.value = true;
  _editLogin.value = false;
}

onMounted(async () => {
  _isAgent22.value = _accountStore.isRoot
  _form.value.removeRules("Email")
  _form.value.removeRules("Loginname")
//  _isShowEmail.value = _accountStore.actionPerson?.id === "person_getmann"
//  _isShowEmail.value = _accountStore.isRoot;
  _isShowEmail.value = true;
  if (_isShowEmail.value) {
    _form.value.addRules({name: 'Loginname', rules: {required: [true]}})
    _form.value.addRules({name: 'Email', rules: {email: true}})
  } else {
    _form.value.addRules({name: 'Loginname', rules: {required: [true], email: true}})
  }
})


async function onSaveEmail() {
  if (!_accountStore.hasAction(Action.AccountManage)) {
    notificationService.error("Zugriff verweigert")
    return;
  }
  if (!_form.value.validate())
    return

  const res = await apiOrganisationStructure.updateAccount(_loginName.value, _email.value, _twoFactorAuthentication.value)
  if (res) {
    notificationService.info("Benutzer wurde geändert.")
    _edit.value = false
    _create.value = false;
    _checked.value = false;
    _editLogin.value = false;
    doChange();
  }
}

watch(props, () => {
  _loginName.value = props.account?.loginName ?? ""
  _email.value = props.account?.email ?? ""
  _twoFactorAuthentication.value = props.account?.twoFactorAuthentication ?? false
  _isShowTooFactor.value = (props.person?.isBranch() ?? false) || _accountStore.actionPerson?.id === "person_getmann"
})

function p_createPassword() {
  return getGuid().substring(0, 8)
}

</script>

<style scoped>
td {
  padding-right: 10px;
}

.sog-card {
  min-width: 100px;
  width: auto;
  padding-top: 12px;
}

</style>
